import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DefaulHeader from '../../Layout/DefaultHeader';
import Navbar1 from '../../Layout/Navbar1';
import Card from '../Card/Card';
import {addItem} from '../../Cart/CartHelpers';
import{Redirect} from 'react-router-dom';
import Spinner from '../../Spinner/Spinner';



function Detail(props) {
    const [product, setProduct] = useState('');
    const [relatedProduct,setRelatedProduct] = useState([]);
    const [redirect,setRedirect] = useState(false);
    const [loading,setLoading] =useState(true);

    const addToCart =()=>{
        addItem(product,()=>{
            setRedirect(true);
        })
    }

    const showRedirect=(redirect)=>{
        let path = window.location.href.split('/');
        if(redirect)
        {
            if(path[path.length-1].length>0){
                return <Redirect to={`/product/${path[path.length-1]}`}/>;
            }
            return <Redirect to="/"/>;
        }
    };

   
    const fetchProduct = (productId)=> {
        axios.get(`/product/${productId}`)
        .then(pro => {
            setProduct(pro.data.product);
            setLoading(false);
        })
        .catch(err => console.log(err));
    }

    const fetchRelatedProduct=(productId) =>{
        axios.get(`/products/related/${productId}`)
        .then(rePro=>{
            // console.log(rePro)
            setRelatedProduct(rePro.data.products);
        }).catch(err=>console.log(err));
    }

    useEffect(() => {
        const productId = props.match.params.productId;
        fetchProduct(productId);
        fetchRelatedProduct(productId);
    },[props]);//executed useEffect() when props change mean url change
    
    return ( 
        <React.Fragment>

        <Navbar1/>
        <DefaulHeader/>
        <div className="container">
                    <br/>
            <div className="row">
       {(loading&&(<Spinner/>))||(
           <div className="col-md-9">
           <div className="col-10 mx-auto text-center text-slanter text-blue my-5">
               <h1>
               {product.name}
               </h1>
           </div>
           <hr/>
           <div className="row">
               <div className="col-10 mx-auto col-md-6 my-3 text-capitalize">
                   <img src={`https://nhathuocvantien.herokuapp.com/api/product/photo/${product._id}`} alt={product.name} className="img-fluid"/>
               </div>
               <div className="col-10 mx-auto col-md-6 my-3 text-capitalize" style={{borderLeft:"1px inset"}}>
               <h2>{product.name}</h2>
               {/* <h4 className="text-title text-uppercase text-muted mt-3 mb-2">
                   made by : <span className="text-uppercase">vantien</span>
               </h4> */}
               <h4 className="text-blue">
                   <strong>
                   Giá:{ product.price+",000"}<sup>đ</sup>
                   </strong>
               </h4>
               <p className="text-capitalize font-weight-bold mt-3 mb-0">
                   Thông tin sản phẩm:
               </p>
               <p className="">
                   {product.description}
               </p>
                   {/* button */}
                   <button onClick={addToCart} className="btn btn-primary">THÊM VÀO GIỎ</button>
                   {showRedirect(redirect)}
               </div>
           </div>
       </div>

       )}
       
                    <div className="col-md-3 col-sm-3">
                        <p style={{fontWeight:"bold",textAlign:"center"}}>Có thể bạn quan tâm</p>
                            {relatedProduct.map((p,i)=>(
                                <div key={i} className="mb-3">
                                    <Card  product={p}/>
                                </div>
                            ))}
                    </div>

            </div>
        </div>

        </React.Fragment>

    )
     
}

export default Detail;